import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-header-container" }
const _hoisted_2 = { class: "c-header-details-container" }
const _hoisted_3 = { class: "header-text" }
const _hoisted_4 = { class: "c-header-buttons-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _renderSlot(_ctx.$slots, "search"),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.header), 1),
      _renderSlot(_ctx.$slots, "breadcrumb")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "buttons")
    ])
  ]))
}